// extracted by mini-css-extract-plugin
module.exports = {"ParentDiv":"PaginationButton_ParentDiv__3Tfud","BabyDiv":"PaginationButton_BabyDiv__3ZVqy"};